import { DesignThemeColorPaletteConfiguration } from '@celum/portals/domain';
import { ColorGroup } from '@celum/shared/domain';

export function createColorPalettes(colorPaletteConfiguration: DesignThemeColorPaletteConfiguration): ColorGroup[] {
  return [
    {
      name: 'PORTALS.COLOR_PICKER.BRAND',
      colors: [colorPaletteConfiguration.primaryColor, colorPaletteConfiguration.contrastColor, ...colorPaletteConfiguration.customColors]
    },
    {
      name: 'PORTALS.COLOR_PICKER.LAYOUT',
      colors: colorPaletteConfiguration.grayScaleColors
    }
  ];
}
